import { HOME_DIRECTION_ICON_PATHS } from './homeDirectionIcons.ts';
import { SPECIAL_TOPIC } from '../utils/problemUrls.ts';

/** Метаданные тем каталога (как в ProblemsList), без «Специальные». */
export const PROFILE_DIRECTIONS = [
  { topic: 'SQL', iconKey: 'sql' as const, labelKey: 'homePage.dirSql' },
  { topic: 'Algorithms', iconKey: 'algorithms' as const, labelKey: 'homePage.dirAlgorithms' },
  { topic: 'Data Analysis', iconKey: 'pandas' as const, labelKey: 'profile.topicDataAnalysis' },
  { topic: 'Math', iconKey: 'math' as const, labelKey: 'homePage.dirMath' },
  { topic: 'Physics', iconKey: 'physics' as const, labelKey: 'homePage.dirPhysics' },
] as const;

export type ProfileDirectionTopic = (typeof PROFILE_DIRECTIONS)[number]['topic'];

export function getDirectionMeta(topic: string) {
  return PROFILE_DIRECTIONS.find((d) => d.topic === topic);
}

export function directionLabel(topic: string, t: (key: string) => string): string {
  const meta = getDirectionMeta(topic);
  return meta ? t(meta.labelKey) : topic;
}

export function directionIconPath(topic: string): string | null {
  const meta = getDirectionMeta(topic);
  return meta ? HOME_DIRECTION_ICON_PATHS[meta.iconKey] : null;
}

export function catalogProgressTopics(topics: string[] | undefined | null): string[] {
  const source = Array.isArray(topics) && topics.length > 0
    ? topics
    : [...PROFILE_DIRECTIONS.map((d) => d.topic)].sort((a, b) => a.localeCompare(b));
  return source.filter((topic) => Boolean(topic) && topic !== 'All' && topic !== SPECIAL_TOPIC);
}

export { HOME_DIRECTION_ICON_PATHS };
